import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="min-h-screen pt-20 flex items-center justify-center px-6">
      <div className="max-w-md w-full text-center border border-line p-12">
        <p className="text-[11px] uppercase tracking-ultra text-accent">Checkout cancelled</p>
        <h1 className="mt-6 font-serif text-4xl text-ink">No payment was made</h1>
        <p className="mt-3 text-sm text-ink-soft">Your card was not charged. You can return to the course whenever you're ready.</p>
        <Link to="/salotto-digitale" className="mt-8 inline-block bg-ink text-bg px-10 py-4 text-[11px] uppercase tracking-[0.2em] hover:bg-[#33312E] transition-colors">Back to courses</Link>
      </div>
    </div>
  );
}
